module.exports = __webpack_public_path__ + "img/icon-use-secureship.7a77744a.svg";